const theme = {
  light: {
    optionColor: "#fff",
    mainBg: "#f5f5f5",
    cardBg: "white",
    textColor: "black",
    cardHeaderColor: "black",
    iconColor: "black",
    loginPage: {
      bg: "#101727",
      text: "#101727",
    },
    dashboard: {
      sidebarBg: "#101727",
      sidebarItemActive: "#13b2ec",
    },
  },
  dark: {
    optionColor: "white",
    mainBg: "#23272f",
    cardBg: "#343a46",
    textColor: "white",
    cardHeaderColor: "white",
    iconColor: "white",
    loginPage: {
      bg: "#101727",
      text: "#101727",
    },
    dashboard: {
      sidebarBg: "#343a46",
      sidebarItemActive: "#13b2ec",
    },
  },
};
export const { light, dark } = theme;
export default theme;
